import {Option, option} from "ts-option";

/**
 * Dictionary cache. Store data under string key.
 */
export default class DictionaryCache<T> {
	/**
	 * Store for data.
	 */
	private cache: { [key: string]: T };

	/**
	 * Maximum number of records
	 * @type {number}
	 */
	private maximumNumberOfRecords = 100;

	constructor(maximumNumberOfRecords?: number) {
		if (maximumNumberOfRecords) {
			this.maximumNumberOfRecords = maximumNumberOfRecords;
		}
		this.cache = {}
	}

	static empty<T>() {
		return new DictionaryCache<T>()
	}

	/**
	 * Store single element in array collection under the given key.
	 * It will override already existing data under given key.
	 * @param {string} key key under witch store data.
	 * @param {T} element element to store.
	 */
	store(key: string, element: T) {
		this.safelyClear();
		this.cache[key] = element;
	}

	/**
	 * Get data stored under given key.
	 * @param {string} key
	 * @return {Option<T[]>}
	 */
	get(key: string): Option<T> {
		return option(this.cache[key])
	}

	/**
	 * Remove value under given key from the cache.
	 * @param {string} key key under which value is supposed to be.
	 */
	remove(key: string) {
		if (this.cache[key]) {
			delete this.cache[key];
		}
	}

	/**
	 * Clear cache if it reach maximum number of records.
	 */
	private safelyClear() {
		if (Object.keys(this.cache).length >= this.maximumNumberOfRecords) {
			this.cache = {};
		}
	}
}